import { useMutation } from '@tanstack/react-query';
import { post } from '../api-client';
import type { CreateAppointmentRequest } from '@/types/scheduling-api';

interface BookResponse {
  id: string;
}

export function useBookAppointment() {
  return useMutation({
    mutationFn: (request: CreateAppointmentRequest) =>
      post<BookResponse>('/api/Appointment/Book', request),
  });
}
